export const environment = {
    production: false,
    strapiUrl: "https://strapi-api-uat.riv-nonprod.liiaws.net",
    apiPath: "api",
    API_URL: 'https://canuck.livingston.com/rivapi',
    API_URL_PLATFORM: 'https://canuck.livingston.com/platformapi',
    API_LEGACY: 'https://uat.riv.ca/RivolutionAPI/api',
    strapiToken: 'cfaa4f54143fbf21475fae681bb658d9debbcf2dbcf18706e5ec8199fcfadc089651d536eb5dc03f6b49be16c19b15bade1ad2aa754e621ccdd47da3a243ee8ef47a527aea7831ff43a0379ed7e336c75e94866f5c3f41ce29f6c36755c0dfa3010427e4a1fc97d43989637f8c048ea187363f05ce853a2be40c7e2458acaf09',
    recaptcha: {
        siteKey: '6Lej3fEpAAAAAJ2QCWErPn-BE8LTk7QuvvXyWDNg',
    },
    gtm: {
        id: 'G-3C9CNQYESG',
        containerId: 'GTM-TTQKN7B2'
    },
    robotsMeta: 'noindex, nofollow',
    STRIPE_API_KEY: 'pk_test_51Mb5bHE1bkj1Vmdo967AgNvgcWTm0AjpMFZSGmbsKm3YxusUhX2wpjl2rWgcM3vTSn0f9cwIIAjbuq5jSslQJp7K00mI7attuz',
    ROLLBAR_TOKEN: 'bf7c2e952604475398ea9a786df304ba',
    ROLLBAR_ENV: 'UAT'
};
